import React, { Component } from 'react';
import CustomDropdown from '../CustomDropdown/CustomDropdown';
import classess from './PhoneNumberSelection.scss';
import LoadIndicator from '../../../../../Common/CommonComponents/LoadingIndicator/loadingIndicator';
import { getLocalizedStrings } from '../../mfaPageLocalizedStrings'; 
import classes from '../../../../CPCGuest/GuestBPSearch/guestBPSearch.scss';
class PhoneNumberSelection extends Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('TurnOnMFA'); 
  }

    handleReceiveCodeVia = (event) => {
      this.setState({ receiveCodeVia: event.target.value });
    };

    redirectToProfile = () => {
      app.appUtil.navigateTo(app.appUtil.getAppRoutes().BILLING.SETTINGS_PROFILE);
    }

    formatPhoneNumbers = (number) => {
      return `(${number.slice(0, 3)})${number.slice(3, 6)}-${number.slice(6)}`;
    };
  
  inputErrror = (isSamePhone) => {
      if(isSamePhone){
        return <p className={classess.mfaError}>Phone number already exist. Please enter a valid phone number.</p>;
      }
    };

    render() {
      const {
        phoneNumbers = [],
        selectedPhoneNumber,
        newPhoneNumber = {},
        handleSelectPhoneNumber,
        handleAddPhoneNumber,
        handleCancel,
        handleReceiveCodeVia,
        handlePhoneEncryption,
        showLoader = false,
        showError = false,
        receiveCodeVia,
        fetchPhoneNumbers,
        fromPayment,
        handleViaEmail,
        noPhoneNumberPresent,
        onEnterKeyPress,
        rateChange,
        isSamePhone
      } = this.props;

      const options = phoneNumbers.map((number) => ({ value: number.maskedNumber, label: this.formatPhoneNumbers(number.maskedNumber), encrypted: number.encryptedNumber }));
      if (!fromPayment) {
        options.push({ value: 'add-new', label: 'Add a new number', encrypted: '' });
      }

      const phoneDropdownHide = (fromPayment && noPhoneNumberPresent) ? true : false;

      const disableButton = () => {
        if (showError || !selectedPhoneNumber) {
          return true;
        }
        if ((selectedPhoneNumber === 'add-new') && !(newPhoneNumber.value && newPhoneNumber.value.length === 10 && isSamePhone === false)) {
          return true;
        }
        return false;
      };


      return (
        <div className={classess.phonenumberSelection}>
          {showLoader ? <LoadIndicator showLoading /> :
          <div >
              <div>
              <h3 className={classess.mfaOptInHeading}>{fromPayment ? 'One-Time Code' : 'MFA Opt-In'}</h3>
              {!phoneDropdownHide && <div className={classess.mfaOptInContent}>
                  {fromPayment ?
                    <div>
                      <p>{this.strings.fromPaymentMessage}</p>

                    </div>
                    :
                    <div>
                      <p>{this.strings.phoneMessage} </p>
                      <p>{this.strings.sendOTPMessage}</p>
                    </div>}
                </div>}

              {showError ?
                  <div className={classes.searchError + ' ' + classess.mfaError}> <div> <p className={classes.warningMsg}>Something went wrong on our end. Please <span onClick={fetchPhoneNumbers} className={classess.mfaPhoneNumberReset}>click here</span> to resubmit. We appreciate your patience.</p></div></div>
                  :
                  (!phoneDropdownHide ? <div> <CustomDropdown
                    options={options}
                    selectedValue={selectedPhoneNumber || 'Select a phone number'}
                    onChange={handleSelectPhoneNumber}
                    onEnterKeyPress={onEnterKeyPress}
                  />
                    {selectedPhoneNumber === 'add-new' && (
                    <div className={classess.mfaNewNumber}>
                      <label className={classess.newNumberLabel}><p className={classess.phoneNumber}>{this.strings.newPhoneNumber}</p>
                        <input
                          type='text'
                          className={classess.mfaPhoneNumber}
                          value={newPhoneNumber.name}
                          maxLength={13}
                          onChange={handleAddPhoneNumber}
                        />
                      </label>
                      {this.inputErrror(isSamePhone)}
                    </div>
                  )}
                    {selectedPhoneNumber && (
                    <div className={classess.mfaRadioContent}>
                      <p className={classess.mfaRadioMessage}>{this.strings.radioMessage}</p>
                      <div>
                        <label>
                          <input
                            type='radio'
                            value='text'
                            aria-label='Text Me'
                            className={classess.radioButton}
                            checked={receiveCodeVia === 'text'}
                            onChange={handleReceiveCodeVia}
                          />
                                                    {this.strings.textMe}
                        </label>
                      </div>
                      <div>
                        <label>
                          <input
                            type='radio'
                            value='call'
                            aria-label='Call Me'
                            className={classess.radioButton}
                            checked={receiveCodeVia === 'call'}
                            onChange={handleReceiveCodeVia}
                          />
                                                    {this.strings.callMe}
                        </label>
                      </div>
                      {fromPayment ? (rateChange && !app.appService.isAuthenticated() && location.pathname.includes("business")) ? '' : <div>
                        <p>{this.strings.otpOptionMessage}</p>
                        <p onClick={handleViaEmail} onKeyDown={(event) => onEnterKeyPress(event,handleViaEmail)} tabIndex={0} className={`${classess.linkColorCursor} ${classess.textUnderline}`}>{this.strings.emailOTP} </p>
                      </div>: ''}
                    </div>
                  )}
                  </div> : <div>
                    <p>{this.strings.emailOtpMessage}</p>
                    <p className={classess.profileMessage}>{this.strings.profileMessage}<span onClick={this.redirectToProfile} onKeyDown={(event) => onEnterKeyPress(event,this.redirectToProfile)} tabIndex={0} className={`${classess.linkColorCursor} ${classess.textUnderline}`}>{this.strings.profileSettings}</span> </p>
                  </div>
                  )}
            </div>
              <div className={classess.modalActions}>
              <button className={classess.mfaSendcode} onClick={!phoneDropdownHide ? handlePhoneEncryption : handleViaEmail} disabled={!phoneDropdownHide && disableButton()} >{!phoneDropdownHide ? this.strings.sendCode : this.strings.emailSendCode}</button>
              <button className={classess.mfaCancel} onClick={handleCancel}>{this.strings.cancel}</button>
            </div>
            </div>
          }
        </div>
      );
    }
}

export default PhoneNumberSelection;
